'use client'

import { useCmsContext } from '@dxp/components/cms'
import { usePushSnack } from '@dxp/components/snackbar'
import { useEffect } from 'react'

export function PasswordChangeToast() {
  const cms = useCmsContext()
  const pushSnack = usePushSnack()

  useEffect(() => {
    const cookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('password-changed-success='))

    if (cookie) {
      pushSnack({
        alert: {
          severity: 'success',
          message: cms['Stepup.UpdatePassword.Web.Success.ToastMessage'],
        },
      })

      // Clear the cookie
      document.cookie =
        'password-changed-success=;  Max-Age=0; path=/; SameSite=Lax; Secure'
    }
  }, [cms, pushSnack])

  return null
}
